import { GateStatusAttribute } from "../../../models/shared/gateStatus";
import { GATE_STATUS } from "../../../enums/gate-status.enum";

export function parseGateStatusAttribute(attribute: unknown): GateStatusAttribute | undefined {
  if (!attribute || typeof attribute !== "object" || !("value" in attribute) || !("timestamp" in attribute)) {
    return undefined;
  }

  const { value, timestamp } = attribute;
  if (timestamp !== null && (typeof timestamp !== "number" || !Number.isFinite(timestamp))) {
    return undefined;
  }

  switch (value) {
    case GATE_STATUS.OPEN:
    case GATE_STATUS.OPENING:
    case GATE_STATUS.PARTIAL:
    case GATE_STATUS.CLOSING:
    case GATE_STATUS.CLOSE:
      return { value, timestamp };
    default:
      return undefined;
  }
}
